import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

//////
import { PutMethod } from "../../helper/Api";
import PageChange from "../../pageChange";
import Layout from "../../component/Layout/Layout";
import Card from "../../component/Layout/theme/card";
import { Input } from '../../component/form/input'
import { validateForm } from "../../helper/helper";
import { Logout } from "../../redux/featuer/user/userSlice";
import TimerSms from '../../component/time-sms/index'
import toast from "react-hot-toast";

const Profile = () => {
    const [isDataLoad, setIsDataLoad] = useState(false);
    ///redux
    const { login, token } = useSelector((item) => item.user);


    const dispatch = useDispatch();



    const [sms, setSms] = useState("");
    const [password, setPassword] = useState("")
    const [repeatPassword, setRepeatPassword] = useState("")





    useEffect(() => {
        document.title = "تغییر گذرواژه";
        if (!login) {
            document.location.href = "/auth"
            setIsDataLoad(false)

        } else {
            setIsDataLoad(true)
        }

    }, [login])


    const submitForm = async (e) => {
        //refresh nashodn site bade click
        e.preventDefault();
        if (validateForm(e)) {

            if (password.length <= 4) {
                return toast.error("پسورد را قوی تر وارد کنید")
            }

            if (password !== repeatPassword) {
                return toast.error("پسورد با هم مطابقت ندارد")
            }

            var body2 = {
                code: sms,
                password: password
            }
            setIsDataLoad(false)
            var url = `/api/user/login/change/password`;
            PutMethod(
                { url: url, body: body2, token: token },
                (res) => {
                    if (res.status === "success") {
                        dispatch(Logout())
                        setIsDataLoad(true)
                        toast.error("عملیات با موفقیت انجام شد");
                        document.location.href = "/auth"
                    }
                    setIsDataLoad(true)
                },
                (error) => {
                    setIsDataLoad(true)
                    toast.error(error.response.data.msg);
                }
            );
        }
    };







    return (
        <>
            {isDataLoad ? (
                <>
                    <Layout >
                        <Card >
                            <form onSubmit={submitForm} className="p-3 !py-5 mx-auto  bg-white rounded-lg shadow-md lg:w-[60%] felx" >
                                <div className="">
                                    <div className="relative flex mt-3 ">
                                        <Input
                                            className={'w-90'}
                                            placeholder="پیامک دریافت شده"
                                            type="text"
                                            value={sms}
                                            id={"sms"}
                                            name={"sms"}
                                            autoComplete={"off"}
                                            requiredir={true}
                                            onChange={(e) => setSms(e.target.value)}
                                        />

                                        <div className="pr-3">
                                            <TimerSms />
                                        </div>
                                    </div>
                                    <div className="relative mt-3 ">
                                        <Input
                                            className={'w-90'}
                                            placeholder="پسورد جدید"
                                            type="password"
                                            value={password}
                                            requiredir={true}
                                            onChange={(e) => setPassword(e.target.value)}
                                            id={"password"}
                                            name={"password"}
                                            autoComplete={"off"}
                                            disabled={false}
                                        />
                                    </div>

                                    <div className="relative mt-3">
                                        <Input
                                            className={'w-90'}
                                            placeholder="تکرار پسورد"
                                            type="password"
                                            onChange={(e) => setRepeatPassword(e.target.value)}
                                            value={repeatPassword}
                                            id={"repeat-password"}
                                            name={"repeat-password"}
                                            autoComplete={"off"}
                                            requiredir={true}

                                            disabled={false}
                                        />
                                    </div>
                                </div>


                                <div className="relative flex justify-center mt-4">
                                    <button
                                        className="h-10 text-white bg-green-500 rounded-lg w-52 "
                                        type="submit"
                                    >
                                        تغییر گذرواژه
                                    </button>
                                </div>
                            </form>
                        </Card>
                    </Layout>


                </>
            ) : (
                <PageChange />
            )
            }
        </>


    )
}


export default Profile;




//   ) :
// <>
//

// </>